export default __webpack_public_path__ + "static/media/1539.3ffaee6a.png";